(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[83855,79647],{

/***/ 72728:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/symbol/[symbol]/chartbit",
      function () {
        return __webpack_require__(17803);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 17803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ chartbit; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Watchlist/Orderbook/slice.ts
var slice = __webpack_require__(18388);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/features/paywall/store/index.ts + 1 modules
var store = __webpack_require__(92182);
// EXTERNAL MODULE: ./src/features/paywall/types.ts
var types = __webpack_require__(5072);
// EXTERNAL MODULE: ./src/features/paywall/constants.ts
var constants = __webpack_require__(11298);
;// CONCATENATED MODULE: ./src/features/paywall/store/useChartbit.ts





function useChartbit(symbol) {
    var ref = (0,store/* default */.Z)(function(state) {
        return {
            isPro: state.company.isPro,
            isRenewal: state.company.isRenewal,
            isLoading: state.company.isLoading,
            getStatus: state.getStatus,
            addCounter: state.addCounter
        };
    }, shallow/* default */.Z), isPro = ref.isPro, isLoading = ref.isLoading, isRenewal = ref.isRenewal, getStatus = ref.getStatus, addCounter = ref.addCounter;
    (0,react.useEffect)(function() {
        if (!symbol) return;
        var feature = constants/* PaywallFeatureEnum.CHARTBIT */.qU.CHARTBIT;
        getStatus({
            key: types/* SectionEnum.company */.P.company,
            feature: feature,
            company: symbol
        });
        addCounter({
            feature: feature,
            company: symbol
        });
    }, [
        symbol
    ]);
    return {
        isPro: isPro,
        isLoading: isLoading,
        isRenewal: isRenewal
    };
}
/* harmony default export */ var store_useChartbit = (useChartbit);

// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/lib/stores/tradingData.ts + 1 modules
var tradingData = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/global/TradingModal/hooks/useSyariah.ts
var useSyariah = __webpack_require__(47060);
// EXTERNAL MODULE: ./src/features/transaction/provider.tsx + 1 modules
var provider = __webpack_require__(207);
// EXTERNAL MODULE: ./src/lib/flipt/constants/flagKeys.ts
var flagKeys = __webpack_require__(34540);
// EXTERNAL MODULE: ./src/lib/flipt/constants/env.ts
var env = __webpack_require__(34737);
// EXTERNAL MODULE: ./src/lib/flipt/hooks/index.ts + 1 modules
var hooks = __webpack_require__(62514);
// EXTERNAL MODULE: ./src/global/MainLayout/slice.js
var MainLayout_slice = __webpack_require__(48153);
// EXTERNAL MODULE: ./src/hooks/useProfileData.ts
var useProfileData = __webpack_require__(30995);
// EXTERNAL MODULE: ./src/hooks/useNotificationListener.ts
var useNotificationListener = __webpack_require__(91364);
// EXTERNAL MODULE: ./src/features/chartbit/styled.ts
var styled = __webpack_require__(72950);
;// CONCATENATED MODULE: ./src/features/chartbit/Layout.tsx







var SideWidget = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(46312), __webpack_require__.e(74749), __webpack_require__.e(6581)]).then(__webpack_require__.bind(__webpack_require__, 69908));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69908)
            ];
        }
    },
    ssr: false
});
var ModalErrorManager = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 51906).then(__webpack_require__.bind(__webpack_require__, 51906));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51906)
            ];
        }
    },
    ssr: false
});
var ModalAuthSecurities = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(38305), __webpack_require__.e(62366)]).then(__webpack_require__.bind(__webpack_require__, 62366));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62366)
            ];
        }
    },
    ssr: false
});
var GlobalModalManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33082), __webpack_require__.e(1013), __webpack_require__.e(74673), __webpack_require__.e(38305), __webpack_require__.e(87109), __webpack_require__.e(61442), __webpack_require__.e(88115), __webpack_require__.e(29678)]).then(__webpack_require__.bind(__webpack_require__, 89994));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89994)
            ];
        }
    },
    ssr: false
});
var DatafeedModalManager = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 44992).then(__webpack_require__.bind(__webpack_require__, 44992));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44992)
            ];
        }
    },
    ssr: false
});
function ChartbitLayout(param) {
    var children = param.children;
    (0,useProfileData/* default */.Z)();
    (0,useNotificationListener/* default */.Z)();
    var ref = (0,es/* useSelector */.v9)(MainLayout_slice/* selectors */.wl), isSideWidgetOpen = ref.isSideWidgetOpen, isMarketOpen = ref.isMarketOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ChartbitLayoutWrapper */.KK, {
                isSideWidgetOpen: isSideWidgetOpen,
                isMarketOpen: isMarketOpen,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalErrorManager, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAuthSecurities, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalModalManager, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatafeedModalManager, {})
        ]
    });
}
/* harmony default export */ var Layout = (ChartbitLayout);

// EXTERNAL MODULE: ./src/features/chartbit/TradingView/utils.ts + 1 modules
var utils = __webpack_require__(74955);
// EXTERNAL MODULE: ./src/features/chartbit/Modal/TradingModals.tsx + 1 modules
var TradingModals = __webpack_require__(96011);
// EXTERNAL MODULE: ./src/features/chartbit/TradingView/trading.ts
var trading = __webpack_require__(68152);
;// CONCATENATED MODULE: ./src/features/chartbit/Web.tsx




















var orderbookActions = slice/* default.actions */.ZP.actions;
var Chartbit = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(37943), __webpack_require__.e(54335)]).then(__webpack_require__.bind(__webpack_require__, 37943));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37943)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var ChartbitMyInvestment = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(46066), __webpack_require__.e(10605), __webpack_require__.e(4965), __webpack_require__.e(8377)]).then(__webpack_require__.bind(__webpack_require__, 14833));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14833)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var TradeButton = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 33781).then(__webpack_require__.bind(__webpack_require__, 33781));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33781)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var Paywall = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(91036), __webpack_require__.e(40927), __webpack_require__.e(77284), __webpack_require__.e(74673), __webpack_require__.e(53120), __webpack_require__.e(84417)]).then(__webpack_require__.bind(__webpack_require__, 75479));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75479)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var Menu = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 25778).then(__webpack_require__.bind(__webpack_require__, 25778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25778)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var ChartbitWeb = function(param) {
    var symbol = param.symbol;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(""), theme = ref[0], setTheme = ref[1];
    var ref1 = (0,react.useState)(null), portoData = ref1[0], setPortoData = ref1[1];
    var ref2 = (0,react.useState)(null), orderData = ref2[0], setOrderData = ref2[1];
    var ref3 = (0,react.useState)(null), cancelData = ref3[0], setCancelData = ref3[1];
    var ref4 = (0,react.useState)(false), isChartReady = ref4[0], setChartReady = ref4[1];
    var ref5 = (0,react.useState)(true), hideLogo = ref5[0], setHideLogo = ref5[1];
    var hide = (0,react.useRef)(hideLogo);
    var ref6 = (0,react.useState)((0,utils/* isWidgetbarMinimized */.zV)()), isWBMinimized = ref6[0], setIsWBMinimized = ref6[1];
    var isMounted = (0,react.useRef)(false);
    var syariahData = (0,useSyariah/* default */.Z)();
    var ref7 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), _data = ref7.data, userId = _data.id;
    var ref8 = store_useChartbit(symbol), isPro = ref8.isPro, isLoading = ref8.isLoading, isRenewal = ref8.isRenewal;
    (0,react.useEffect)(function() {
        // @ts-ignore
        var username = auth/* default.getUserAccess */.Z.getUserAccess().username;
        if (!userId) {
            // @ts-ignore
            dispatch(profile/* effects.getUserProfile */.Sz.getUserProfile(username));
        }
        isMounted.current = true;
    }, [
        dispatch,
        userId
    ]);
    var handleChartReady = (0,react.useCallback)(function() {
        hide.current = !(0,utils/* isSideToolbarOpen */.WS)();
        setHideLogo(hide.current);
        setChartReady(true);
    }, []);
    var handleChartUnmount = (0,react.useCallback)(function() {
        return setChartReady(false);
    }, []);
    var handleToggleSidebar = (0,react.useCallback)(function(isHide) {
        hide.current = isHide;
        setHideLogo(hide.current);
    }, [
        setHideLogo
    ]);
    var handleToggleWidgetbar = (0,react.useCallback)(function(minimized) {
        setIsWBMinimized(minimized);
    }, []);
    var handleSymbolChange = (0,react.useCallback)(function(targetSymbol) {
        // Sync App Router Symbol with TradingView Active Symbol
        // https://github.com/vercel/next.js/issues/18127
        router_default().push("/symbol/".concat(targetSymbol, "/chartbit"), undefined, {
            shallow: true
        });
        // Syns Sidewidget Orderbook Symbol
        dispatch(orderbookActions.setSymbol({
            symbol: targetSymbol
        }));
    }, []);
    var handleResolveSymbolError = (0,react.useCallback)(function(err, errSymbol) {
        var ref;
        // handle paywall error
        var errorType = err === null || err === void 0 ? void 0 : (ref = err.cause) === null || ref === void 0 ? void 0 : ref.errorType;
        if (errorType === errorMessage/* default.PAYWALL_ERROR */.Z.PAYWALL_ERROR) {
            var redirectUrl = "/symbol/".concat(errSymbol, "/chartbit");
            router_default().push(redirectUrl);
        }
    }, []);
    var handleChangeTheme = function(value) {
        setTheme(value);
    };
    (0,react.useEffect)(function() {
        if (hideLogo !== hide.current) setHideLogo(hide.current);
    }, [
        hideLogo
    ]);
    var enableTradeFromChart = (0,hooks/* useFliptBoolean */.v)(flagKeys/* FeatureFlagKeys.CHARTBIT_TRADE_FROM_CHART */.O.CHARTBIT_TRADE_FROM_CHART, true, env/* FLIPT_CHARTBIT_NAMESPACE */.Ii);
    if (!isPro && !userId) {
        return null;
    }
    if (!isPro && !isLoading && isMounted.current) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paywall, {
            isRenewal: isRenewal
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(provider/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout, {
            children: [
                isChartReady && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !hideLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu, {
                            symbol: symbol,
                            theme: theme
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeButton, {
                            symbol: symbol
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartbitMyInvestment, {
                            symbol: symbol,
                            isWidgetBarMinimized: isWBMinimized
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chartbit, {
                    theme: "light",
                    symbol: symbol,
                    onChartReady: handleChartReady,
                    onChartUnmount: handleChartUnmount,
                    onToggleSidebar: handleToggleSidebar,
                    onToggleWidgetbar: handleToggleWidgetbar,
                    onSymbolChange: handleSymbolChange,
                    onResolveSymbolError: handleResolveSymbolError,
                    onChangeThemeChartbit: handleChangeTheme,
                    checkTradeableStatus: trading/* checkTradeableStatus */["do"],
                    getCurrentLot: trading/* getCurrentLot */.H6,
                    onOpenTrading: function(data) {
                        (0,trading/* onOpenTrading */.x7)(data, setPortoData, syariahData);
                    },
                    onCancelOrder: function(data) {
                        setCancelData(data);
                    },
                    onOpenPortoDetail: function(sym, isDayTrade) {
                        var newPortoData = (0,trading/* getPortoData */.B8)(sym, isDayTrade);
                        if (newPortoData) {
                            var ref;
                            setPortoData({
                                symbol: sym,
                                isDayTrade: isDayTrade,
                                exerciseable: newPortoData === null || newPortoData === void 0 ? void 0 : (ref = newPortoData.exercise_data) === null || ref === void 0 ? void 0 : ref.active,
                                type: newPortoData === null || newPortoData === void 0 ? void 0 : newPortoData.type
                            });
                        }
                    },
                    onOpenOrderDetail: function(orderId) {
                        var ref;
                        var orderHistory = tradingData/* default.getState */.Z.getState().orderHistory;
                        var order = orderHistory === null || orderHistory === void 0 ? void 0 : (ref = orderHistory.data) === null || ref === void 0 ? void 0 : ref.find(function(o) {
                            return o.orderid === orderId;
                        });
                        if (order) {
                            setOrderData(order);
                        }
                    },
                    enableTradeFromChart: enableTradeFromChart
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingModals/* default */.Z, {
                    portoData: portoData,
                    cancelData: cancelData,
                    orderData: orderData,
                    onClose: function() {
                        setPortoData(null);
                        setCancelData(null);
                        setOrderData(null);
                    },
                    setCancelData: setCancelData,
                    setPortoData: setPortoData
                })
            ]
        })
    });
};
/* harmony default export */ var Web = (ChartbitWeb);

// EXTERNAL MODULE: ./src/global/Loading/PageLoader.jsx + 2 modules
var PageLoader = __webpack_require__(598);
// EXTERNAL MODULE: ./src/global/SEO/index.tsx
var SEO = __webpack_require__(26350);
// EXTERNAL MODULE: ./src/hooks/useProtectedRoute.js
var useProtectedRoute = __webpack_require__(56198);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/symbol/[symbol]/chartbit.tsx

__webpack_require__(14473);







function ChartbitPage() {
    var isLoaded = (0,useProtectedRoute/* default */.Z)().isLoaded;
    var router = (0,next_router.useRouter)();
    var symbol = router.query.symbol;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "stylesheet",
                    href: "".concat(app/* assetPrefix */.Vc, "/css/trading.css")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader["default"], {
                loaded: isLoaded
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Web, {
                symbol: symbol
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var chartbit = (ChartbitPage);


/***/ }),

/***/ 72950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cw": function() { return /* binding */ MaintenanceTitle; },
/* harmony export */   "KK": function() { return /* binding */ ChartbitLayoutWrapper; },
/* harmony export */   "Vz": function() { return /* binding */ MaintenanceBackButton; },
/* harmony export */   "Xb": function() { return /* binding */ MaintenanceContainer; },
/* harmony export */   "dd": function() { return /* binding */ MaintenanceDesc; },
/* harmony export */   "hq": function() { return /* binding */ MyInvestmentWrapper; },
/* harmony export */   "mU": function() { return /* binding */ ErrorContainer; },
/* harmony export */   "n8": function() { return /* binding */ ChartbitWrapper; },
/* harmony export */   "rZ": function() { return /* binding */ MaintenanceModal; },
/* harmony export */   "xG": function() { return /* binding */ ErrorDesc; },
/* harmony export */   "y": function() { return /* binding */ ErrorRetryButton; }
/* harmony export */ });
/* unused harmony export MaintenanceImage */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16368);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74575);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100vh;\n  position: relative;\n\n  /* article > div > div {\n    height: 100vh !important;\n  } */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  position: relative;\n\n  @media ",
        " {\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  position: absolute;\n  top: 42px;\n  right: ",
        ";\n  z-index: 1;\n\n  @media ",
        " {\n    display: ",
        ";\n  }\n\n  & > a > div {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100vh;\n  background-color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction column;\n  padding: 20px;\n\n  img {\n    width: 120px;\n    margin-bottom: 10px;\n  }\n\n  @media ",
        " {\n    img {\n      width: 160px;\n    }\n  }\n\n  @media screen and (max-width: 450px) {\n    img {\n      width: 120px !important;\n    }\n    p:first-of-type {\n      font-size: 16px;\n    }\n    p:nth-of-type(2){\n      font-size: 12px\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 16px;\n  margin-bottom: 8px;\n\n  @media ",
        " {\n    font-size: 24px;\n    margin-bottom: 10px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 16px;\n  margin-bottom: 8px;\n  font-weight: 700;\n\n  @media ",
        " {\n    font-size: 24px;\n    margin-bottom: 10px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  margin-bottom: 0;\n  max-width: 280px;\n\n  @media ",
        " {\n    font-size: 16px;\n    max-width: unset;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 12px 20.5px;\n  border-radius: 100px;\n  margin-top: 30px;\n  display: none;\n\n  @media ",
        " {\n    display: flex;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    border-radius: 3px;\n    background-color: ",
        ";\n  }\n  .ant-modal-header {\n    background-color: ",
        ";\n  }\n  .ant-modal-close {\n    color: ",
        ";\n  }\n  @media screen and (max-width: 700px) {\n    width: 335px !important;\n\n    .ant-modal-title div {\n      height: unset !important;\n      padding-bottom: 12px !important;\n      p {\n        font-size: 16px;\n        line-height: 22px;\n        width: 267px;\n      }\n    }\n\n    .ant-modal-body div {\n      padding-bottom: 20px !important;\n      p {\n        font-size: 13px;\n      }\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100vh;\n  background-color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  padding: 20px;\n\n  @media ",
        " {\n    img {\n      width: 223px;\n      height: 167px;\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  margin-top: 10px;\n  max-width: 319px;\n\n  @media ",
        " {\n    font-size: 18px;\n    font-family: var(--font-bold);\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 12px 20.5px;\n  border-radius: 100px;\n  margin-top: 30px;\n  display: flex;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}





var ChartbitWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1ec62aa1-0"
})(_templateObject());
var ChartbitLayoutWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1ec62aa1-1"
})(_templateObject1(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tablet */ .Z.tablet, function(param) {
    var isSideWidgetOpen = param.isSideWidgetOpen, isMarketOpen = param.isMarketOpen;
    if (!isSideWidgetOpen) {
        return "calc(100% - 48px)";
    }
    if (!isMarketOpen) {
        return "calc(100% - 438px);";
    }
    return "calc(100% - 378px)";
});
var MyInvestmentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1ec62aa1-2"
})(_templateObject2(), function(param) {
    var right = param.right;
    return "".concat(right, "px");
}, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tablet */ .Z.tablet, function(param) {
    var show = param.show;
    return show ? "block" : "none";
});
var MaintenanceContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1ec62aa1-3"
})(_templateObject3(), function(props) {
    return props.background;
}, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tablet */ .Z.tablet);
var MaintenanceImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-1ec62aa1-4"
})(_templateObject4(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tablet */ .Z.tablet);
var MaintenanceTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-1ec62aa1-5"
})(_templateObject5(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tablet */ .Z.tablet);
var MaintenanceDesc = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-1ec62aa1-6"
})(_templateObject6(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tablet */ .Z.tablet);
var MaintenanceBackButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-1ec62aa1-7"
})(_templateObject7(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tablet */ .Z.tablet);
var MaintenanceModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-1ec62aa1-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.color.modals.surfaceDefault;
}, function(param) {
    var theme = param.theme;
    return theme.color.modals.surfaceDefault;
}, function(param) {
    var theme = param.theme;
    return theme.color.text.primary;
});
var ErrorContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1ec62aa1-9"
})(_templateObject9(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tablet */ .Z.tablet);
var ErrorDesc = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-1ec62aa1-10"
})(_templateObject10(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tablet */ .Z.tablet);
var ErrorRetryButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-1ec62aa1-11"
})(_templateObject11());
// eslint-disable-next-line import/prefer-default-export



/***/ }),

/***/ 11298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HY": function() { return /* binding */ PAYWALL_IMAGE_URL; },
/* harmony export */   "LB": function() { return /* binding */ CompanyStreamWidget; },
/* harmony export */   "RQ": function() { return /* binding */ DescriptionText; },
/* harmony export */   "Up": function() { return /* binding */ ButtonNewText; },
/* harmony export */   "Uw": function() { return /* binding */ CompanyWidgetEnum; },
/* harmony export */   "cY": function() { return /* binding */ ButtonContinueText; },
/* harmony export */   "gQ": function() { return /* binding */ CompanyWidgetTitle; },
/* harmony export */   "oz": function() { return /* binding */ OfferingPro; },
/* harmony export */   "pj": function() { return /* binding */ OfferingProText; },
/* harmony export */   "qU": function() { return /* binding */ PaywallFeatureEnum; },
/* harmony export */   "t9": function() { return /* binding */ AddOnWidget; },
/* harmony export */   "z": function() { return /* binding */ HeaderText; }
/* harmony export */ });
/* unused harmony exports IncludedNavbar, ExcludeOldPro, ExcludeOldProPage */
/* eslint-disable no-shadow */ var HeaderText = "Kuota Akses Bulanan Sudah Mencapai Limit";
var DescriptionText = "Nikmati akses seluruh fitur tanpa batas dengan membuka rekening saham di Stockbit Sekuritas.";
var ButtonNewText = "Buka Akses";
var ButtonContinueText = "Lanjut Berlangganan";
var PAYWALL_IMAGE_URL = "/img/paywall";
var OfferingPro = {
    open: {
        title: "Buka Rekening Saham",
        description: "Trading saham di Stockbit Sekuritas dan nikmati semua fitur tanpa batas.",
        iconUrl: "".concat(PAYWALL_IMAGE_URL, "/offering-open-icon.svg")
    },
    subscribe: {
        title: "Berlangganan",
        description: "Berlangganan mulai dari Rp15 ribu/hari untuk nikmati semua fitur tanpa batas.",
        iconUrl: "".concat(PAYWALL_IMAGE_URL, "/offering-subscribe-icon.svg")
    }
};
var OfferingProText = {
    headline: "Nikmati Seluruh Fitur",
    underlined: "Profesional Stockbit",
    unlimited: "Tanpa Batas"
};
var PaywallFeatureEnum;
(function(PaywallFeatureEnum) {
    PaywallFeatureEnum["DEFAULT"] = "PAYWALL_FEATURE_UNSPECIFIED";
    PaywallFeatureEnum["KEYSTATS"] = "PAYWALL_FEATURE_KEYSTATS";
    PaywallFeatureEnum["ANALYST"] = "PAYWALL_FEATURE_ANALYSIS";
    PaywallFeatureEnum["FINANCIALS"] = "PAYWALL_FEATURE_FINANCIALS";
    PaywallFeatureEnum["FUNDACHART"] = "PAYWALL_FEATURE_FUNDACHART";
    PaywallFeatureEnum["SEASONALITY"] = "PAYWALL_FEATURE_SEASONALITY";
    PaywallFeatureEnum["CHARTBIT"] = "PAYWALL_FEATURE_CHARTBIT";
    PaywallFeatureEnum["COMPARISON"] = "PAYWALL_FEATURE_COMPARISON";
    PaywallFeatureEnum["INSIDER"] = "PAYWALL_FEATURE_INSIDER";
    PaywallFeatureEnum["PROFILE"] = "PAYWALL_FEATURE_COMPANY_PROFILE";
    PaywallFeatureEnum["CORPACTION"] = "PAYWALL_FEATURE_CORP_ACTION";
    PaywallFeatureEnum["PRICE_ALERT"] = "PAYWALL_FEATURE_PRICE_ALERT";
    PaywallFeatureEnum["RUNNING_TRADE"] = "PAYWALL_FEATURE_RUNNING_TRADE";
    PaywallFeatureEnum["VALUATION"] = "PAYWALL_FEATURE_VALUATION";
    PaywallFeatureEnum["BANDAR_DETECTOR"] = "PAYWALL_FEATURE_BANDAR_DETECTOR";
    PaywallFeatureEnum["ORDERBOOK"] = "PAYWALL_FEATURE_ORDERBOOK";
    PaywallFeatureEnum["SCREENER"] = "PAYWALL_FEATURE_SCREENER";
    PaywallFeatureEnum["CALENDAR"] = "PAYWALL_FEATURE_CALENDAR";
    PaywallFeatureEnum["EARNINGS"] = "PAYWALL_FEATURE_EARNINGS";
})(PaywallFeatureEnum || (PaywallFeatureEnum = {}));
var CompanyWidgetEnum;
(function(CompanyWidgetEnum) {
    CompanyWidgetEnum["FUNDACHART"] = "FUNDACHART";
    CompanyWidgetEnum["SEASONALITY"] = "SEASONALITY";
    CompanyWidgetEnum["COMPARISON"] = "COMPARISON";
    CompanyWidgetEnum["FINANCIALS"] = "FINANCIALS";
})(CompanyWidgetEnum || (CompanyWidgetEnum = {}));
var IncludedNavbar = (/* unused pure expression or super */ null && ([
    "ORDERBOOK",
    "SCREENER",
    "VALUATION",
    "CALENDAR",
    "EARNINGS", 
]));
var CompanyStreamWidget = [
    "ORDERBOOK",
    "RUNNING_TRADE"
];
var CompanyWidgetTitle = {
    ORDERBOOK: "Orderbook",
    RUNNING_TRADE: "Running Trade",
    TRADE_BOOK: "Trade Book",
    BROKER_SUMMARY: "Broker Summary"
};
var AddOnWidget = "VALUATION";
var ExcludeOldPro = (/* unused pure expression or super */ null && ([
    "analyst",
    "insider",
    "profile",
    "corpaction"
]));
var ExcludeOldProPage = (/* unused pure expression or super */ null && ([
    "ORDERBOOK",
    "CALENDAR",
    "EARNINGS"
]));



/***/ }),

/***/ 92182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ store; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
;// CONCATENATED MODULE: ./src/lib/api/paywall.ts

var request = (0,requestExodus/* default */.Z)(false);
var GET_ELIGIBILITY_STATUS = "/paywall/eligibility/check";
var POST_PAYWALL_COUNTER = "/paywall/counter/increment";
var getPaywallStatus = function(param) {
    var company = param.company, feature = param.feature;
    var params = {
        features: feature
    };
    if (company) {
        params.company = company;
    }
    return request.get(GET_ELIGIBILITY_STATUS, {
        params: params
    });
};
var getMultipleStatus = function(payload) {
    var company = payload.company, feature = payload.feature;
    var companyQs = company ? "company=".concat(company, "&") : "";
    var featuresQs = feature.map(function(f) {
        return "features=".concat(f);
    }).join("&");
    return request.get("".concat(GET_ELIGIBILITY_STATUS, "?").concat(companyQs).concat(featuresQs));
};
var addPaywallCounter = function(param) {
    var company = param.company, feature = param.feature;
    var body = {
        feature: feature
    };
    if (company) {
        body.company = company;
    }
    return request.post(POST_PAYWALL_COUNTER, body);
};
/* harmony default export */ var paywall = ({
    getPaywallStatus: getPaywallStatus,
    getMultipleStatus: getMultipleStatus,
    addPaywallCounter: addPaywallCounter
});

;// CONCATENATED MODULE: ./src/features/paywall/store/index.ts








var sectionState = {
    isLoading: false,
    isRenewal: false,
    isPro: false,
    data: {
        features: [],
        last_subscription: null,
        company: null
    }
};
var initialState = {
    page: sectionState,
    company: sectionState,
    widget: sectionState
};
var useStorePaywall = (0,esm/* default */.ZP)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        getStatus: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                var ref, key, feature, company, isMultiple, payloadFeature, response, data, ref1, newData, ref2, ref3, selectedData, _is_eligible, defaultError;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            key = payload.key, feature = payload.feature, company = payload.company;
                            isMultiple = Array.isArray(feature) && feature.length > 1;
                            payloadFeature = isMultiple ? feature[0] : feature;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                state[key].isLoading = true;
                            }));
                            if (!isMultiple) {
                                _ctx.next = 12;
                                break;
                            }
                            _ctx.next = 9;
                            return paywall.getMultipleStatus(payload);
                        case 9:
                            _ctx.t0 = _ctx.sent;
                            _ctx.next = 15;
                            break;
                        case 12:
                            _ctx.next = 14;
                            return paywall.getPaywallStatus(payload);
                        case 14:
                            _ctx.t0 = _ctx.sent;
                        case 15:
                            response = _ctx.t0;
                            if (!(!response || !response.data || !response.data.data)) {
                                _ctx.next = 18;
                                break;
                            }
                            throw new Error("Error while fetching paywall status");
                        case 18:
                            data = response.data.data;
                            ;
                            newData = {
                                isPro: false,
                                isRenewal: (ref1 = (data === null || data === void 0 ? void 0 : data.last_subscription) !== null) !== null && ref1 !== void 0 ? ref1 : false,
                                isLoading: false,
                                data: data
                            };
                            if (!(company && data.company)) {
                                _ctx.next = 27;
                                break;
                            }
                            ;
                            ;
                            newData.isPro = (ref3 = (ref2 = data.company) === null || ref2 === void 0 ? void 0 : ref2.is_eligible) !== null && ref3 !== void 0 ? ref3 : false;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                Object.assign(state[key], newData);
                            }));
                            return _ctx.abrupt("return", data);
                        case 27:
                            selectedData = (ref = data.features) === null || ref === void 0 ? void 0 : ref.find(function(item) {
                                return item.feature === payloadFeature;
                            });
                            if (selectedData) {
                                ;
                                newData.isPro = (_is_eligible = selectedData.is_eligible) !== null && _is_eligible !== void 0 ? _is_eligible : false;
                            }
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                Object.assign(state[key], newData);
                            }));
                            return _ctx.abrupt("return", data);
                        case 33:
                            _ctx.prev = 33;
                            _ctx.t1 = _ctx["catch"](0);
                            defaultError = "Unknown error while fetching paywall status";
                            if (!(0,_instanceof/* default */.Z)(_ctx.t1, Error)) {
                                _ctx.next = 39;
                                break;
                            }
                            ;
                            return _ctx.abrupt("return", _ctx.t1.message);
                        case 39:
                            ;
                            return _ctx.abrupt("return", defaultError);
                        case 41:
                            _ctx.prev = 41;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                state[payload.key].isLoading = false;
                            }));
                            return _ctx.finish(41);
                        case 44:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        33,
                        41,
                        44
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        addCounter: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                var response, _data, error, errorType, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return paywall.addPaywallCounter(payload);
                        case 3:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 6;
                                break;
                            }
                            throw new Error("Error while post paywall counter");
                        case 6:
                            _data = response.data, error = _data.error, errorType = _data.error_type, message = _data.message;
                            if (!(error || errorType)) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(message);
                        case 9:
                            return _ctx.abrupt("return");
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            if (!(0,_instanceof/* default */.Z)(_ctx.t0, Error)) {
                                _ctx.next = 17;
                                break;
                            }
                            ;
                            return _ctx.abrupt("return");
                        case 17:
                            ;
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetProStatus: function(key) {
            set((0,immer_esm/* default */.ZP)(function(state) {
                state[key].isPro = false;
            }));
        }
    });
});
/* harmony default export */ var store = (useStorePaywall);


/***/ }),

/***/ 5072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ SectionEnum; }
/* harmony export */ });
var SectionEnum;
(function(SectionEnum) {
    SectionEnum["page"] = "page";
    SectionEnum["company"] = "company";
    SectionEnum["widget"] = "widget";
})(SectionEnum || (SectionEnum = {}));


/***/ }),

/***/ 598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Loading_PageLoader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Loading/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0;\n      visibility: hidden;\n      z-index: 1;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: white;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  opacity: 1;\n  position: fixed;\n  top: 0;\n  transition: all 0.3s ease-in-out;\n  visibility: visible;\n  width: 100%;\n  z-index: 1050;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 16px;\n  height: 16px;\n  background-color: #333;\n  margin: 0 5px;\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  transform-origin: center center;\n\n  &:first-child {\n    -webkit-animation-delay: -0.32s;\n    animation-delay: -0.32s;\n  }\n\n  &:nth-child(2) {\n    -webkit-animation-delay: -0.16s;\n    animation-delay: -0.16s;\n  }\n\n  @-webkit-keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n    }\n  }\n\n  @keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n      transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n      transform: scale(1);\n    }\n  }\n\n  @-webkit-keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var LoadingWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-372f28a1-0"
})(_templateObject1(), function(param) {
    var loaded = param.loaded;
    return loaded && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
});
var Bouncer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-372f28a1-1"
})(_templateObject2());


;// CONCATENATED MODULE: ./src/global/Loading/Bouncer.tsx





var Bouncer_Bouncer = function(param) {
    var _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
        condition: isLoading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {})
            ]
        })
    });
};
/* harmony default export */ var Loading_Bouncer = (Bouncer_Bouncer);

;// CONCATENATED MODULE: ./src/global/Loading/PageLoader.jsx





function PageLoader(param) {
    var loaded = param.loaded;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWrapper, {
        loaded: loaded,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading_Bouncer, {})
    });
}
PageLoader.propTypes = {
    loaded: (prop_types_default()).bool
};
PageLoader.defaultProps = {
    loaded: false
};
// always re-render (event no visual visiblity) => need memo
/* harmony default export */ var Loading_PageLoader = (/*#__PURE__*/react.memo(PageLoader));


/***/ }),

/***/ 18388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mb": function() { return /* binding */ symbolSelector; },
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61876);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lib_api_orderbook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83384);
/* harmony import */ var lib_api_search__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44590);
/* harmony import */ var features_orderbook_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51346);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85440);





// libs


// types


var initialState = {
    requestStatus: "idle",
    isSearchbarActive: false,
    offerSectionStatus: "idle",
    symbol: "IHSG",
    name: "Indeks Harga Saham Gabungan",
    lastprice: null,
    change: null,
    percentageChange: null,
    keyword: "",
    searchResult: [],
    ohlc: null,
    offer: null,
    isBidOfferExists: false,
    summary: null,
    priceData: null,
    orderbookPriceData: {},
    error: null,
    previous: 0,
    orderbook: null
};
var reducers = {
    setisSearchbarActive: function(draft, action) {
        draft.isSearchbarActive = action.payload.isOpen;
    },
    setSymbol: function(draft, action) {
        draft.symbol = action.payload.symbol;
    }
};
// selectors
var selfSelector = function(state) {
    return state.mainLayout.watchlist.orderbook;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(selfSelector, function(state) {
    return state;
});
var symbolSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(function(state) {
    return state.mainLayout.watchlist.orderbook.symbol;
}, function(state) {
    return state;
});
// thunk actions
var CONTEXT = "ORDERBOOK_WIDGET";
var fetchOrderbook = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("".concat(CONTEXT, "/FETCH_ORDERBOOK"), function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var symbol, response, companyResponse, _data, responseData, error, _data1, compData, compError, data, previous, ohlc, isOfferExists, isBidExists, priceData, orderbookPriceData, summary, isBidOfferExists, bid, offer, lastprice, change, percentageChange;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    symbol = param.symbol;
                    _ctx.next = 3;
                    return lib_api_orderbook__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getOrderbookPreviewBySymbol */ .Z.getOrderbookPreviewBySymbol(symbol);
                case 3:
                    response = _ctx.sent;
                    _ctx.next = 6;
                    return lib_api_orderbook__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getCompanyInfo */ .Z.getCompanyInfo(symbol);
                case 6:
                    companyResponse = _ctx.sent;
                    _data = response.data, responseData = _data.data, error = _data.error;
                    _data1 = companyResponse.data, compData = _data1.data, compError = _data1.error;
                    data = (0,features_orderbook_utils__WEBPACK_IMPORTED_MODULE_4__/* .transformNewOrderbookListToExisting */ .M6)(responseData);
                    previous = data.previous;
                    if (!(error || compError)) {
                        _ctx.next = 13;
                        break;
                    }
                    throw new Error(error || compError);
                case 13:
                    ohlc = function(param) {
                        var previous = param.previous, change = param.change, percentage_change = param.percentage_change, frequency = param.frequency, open = param.open, high = param.high, low = param.low, fbuy = param.fbuy, volume = param.volume, value = param.value, average = param.average, fsell = param.fsell, close = param.close, lastprice = param.lastprice, symbol = param.symbol, exchange = param.exchange, ara = param.ara, arb = param.arb;
                        return {
                            previous: previous,
                            change: change,
                            percentage_change: percentage_change,
                            frequency: frequency,
                            open: open,
                            high: high,
                            low: low,
                            fbuy: fbuy,
                            volume: volume,
                            value: value,
                            average: average,
                            fsell: fsell,
                            close: close,
                            lastprice: lastprice,
                            symbol: symbol,
                            exchange: exchange,
                            ara: ara,
                            arb: arb
                        };
                    }(data);
                    isOfferExists = Boolean(!!data.offer && typeof data.offer === "object" && Object.keys(data.offer).length > 0);
                    isBidExists = Boolean(!!data.bid && typeof data.bid === "object" && Object.keys(data.bid).length > 0);
                    priceData = null;
                    orderbookPriceData = {};
                    summary = null;
                    isBidOfferExists = isBidExists || isOfferExists;
                    if (isBidOfferExists) {
                        bid = (data === null || data === void 0 ? void 0 : data.bid) || {};
                        offer = (data === null || data === void 0 ? void 0 : data.offer) || {};
                        orderbookPriceData = {
                            bid: bid,
                            offer: offer
                        };
                    }
                    lastprice = numeral__WEBPACK_IMPORTED_MODULE_1___default()(data.lastprice).format("0,0[.]00");
                    change = numeral__WEBPACK_IMPORTED_MODULE_1___default()(data.change).format("0");
                    percentageChange = "".concat(numeral__WEBPACK_IMPORTED_MODULE_1___default()(data.percentage_change).format("0.00"), "%");
                    (0,_store__WEBPACK_IMPORTED_MODULE_5__/* .setValue */ .sO)({
                        key: "liveprice",
                        symbol: data.symbol,
                        type: "update_general_pricedata",
                        value: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, data)
                    });
                    return _ctx.abrupt("return", {
                        isBidOfferExists: isBidOfferExists,
                        ohlc: ohlc,
                        lastprice: lastprice,
                        change: change,
                        percentageChange: percentageChange,
                        name: compData.name,
                        priceData: priceData,
                        summary: summary,
                        previous: previous,
                        orderbookPriceData: orderbookPriceData,
                        orderbook: data
                    });
                case 26:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_) {
        return _ref.apply(this, arguments);
    };
}());
var fetchSymbolSuggestions = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("".concat(CONTEXT, "/FETCH_SUGGESTIONS"), function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var keyword, response, _data, data, error;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    keyword = param.keyword;
                    _ctx.next = 3;
                    return lib_api_search__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getSearchCompany */ .Z.getSearchCompany(keyword);
                case 3:
                    response = _ctx.sent;
                    _data = response.data, data = _data.data, error = _data.error;
                    if (!error) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error(error);
                case 7:
                    return _ctx.abrupt("return", {
                        company: data.company
                    });
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_) {
        return _ref.apply(this, arguments);
    };
}());
var effects = {
    fetchOrderbook: fetchOrderbook,
    fetchSymbolSuggestions: fetchSymbolSuggestions
};
// thunks reducers
var extraReducers = function(builder) {
    // fetch orderbook details
    builder.addCase(fetchOrderbook.pending, function(draft) {
        draft.requestStatus = "pending";
        draft.error = null;
    }).addCase(fetchOrderbook.fulfilled, function(draft, action) {
        draft.requestStatus = "loaded";
        draft.isBidOfferExists = action.payload.isBidOfferExists;
        draft.ohlc = action.payload.ohlc;
        draft.lastprice = action.payload.lastprice;
        draft.change = action.payload.change;
        draft.percentageChange = action.payload.percentageChange;
        draft.name = action.payload.name;
        draft.priceData = action.payload.priceData;
        draft.summary = action.payload.summary;
        draft.previous = action.payload.previous;
        draft.orderbookPriceData = action.payload.orderbookPriceData;
        draft.orderbook = action.payload.orderbook;
    }).addCase(fetchOrderbook.rejected, function(draft, action) {
        draft.error = action.error;
    })// fetch company suggestions
    .addCase(fetchSymbolSuggestions.pending, function(draft) {
        draft.error = null;
    }).addCase(fetchSymbolSuggestions.fulfilled, function(draft, action) {
        draft.searchResult = action.payload.company;
    }).addCase(fetchSymbolSuggestions.rejected, function(draft, action) {
        draft.error = action.error;
    });
};
var orderbookSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSlice */ .oM)({
    name: "orderbook",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (orderbookSlice);


/***/ }),

/***/ 85440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "av": function() { return /* binding */ useOrderbookStore; },
/* harmony export */   "sO": function() { return /* binding */ setValue; }
/* harmony export */ });
/* unused harmony exports OrderbookState, setValueBatch */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);




var OrderbookState = {
    liveprice: {}
};
var useOrderbookStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(_set, _get, _store, _storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, OrderbookState);
});
var handleUpdateGeneralPriceData = function(draft, payload, isInit) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, draft, isInit ? payload : {}), {
        average: payload.average,
        change: payload.change,
        close: payload.close,
        frequency: payload.frequency,
        fsell: payload.fsell,
        high: payload.high,
        id: payload.id,
        lastprice: payload.lastprice,
        low: payload.low,
        open: payload.open,
        percentage_change: payload.percentage_change,
        previous: payload.previous,
        symbol: payload.symbol,
        value: payload.value,
        volume: payload.volume,
        time: payload === null || payload === void 0 ? void 0 : payload.time
    });
};
var handleUpdateOrderbookPriceData = function(draft, payload) {
    if (payload.bid) {
        draft.bid = payload.bid;
    }
    if (payload.offer) {
        draft.offer = payload.offer;
    }
    return draft;
};
var handleUpdateIepIev = function(draft, payload) {
    var ref, ref1;
    draft.iepiev = payload ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, draft === null || draft === void 0 ? void 0 : draft.iepiev), {
        iep: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, draft === null || draft === void 0 ? void 0 : (ref = draft.iepiev) === null || ref === void 0 ? void 0 : ref.iep), {
            raw: payload.iep
        }),
        iev: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, draft === null || draft === void 0 ? void 0 : (ref1 = draft.iepiev) === null || ref1 === void 0 ? void 0 : ref1.iev), {
            raw: payload.iev
        })
    }) : null;
    return draft;
};
var TYPE_SET = {
    "update_general_pricedata_liveprice": function(draft, payload) {
        return handleUpdateGeneralPriceData(draft, payload, false);
    },
    "update_orderbook_pricedata_liveprice": function(draft, payload) {
        return handleUpdateOrderbookPriceData(draft, payload);
    },
    "update_general_pricedata": function(draft, payload) {
        return handleUpdateGeneralPriceData(draft, payload, true);
    },
    "update_iepiev": handleUpdateIepIev
};
var setValue = function(param) {
    var key = param.key, value = param.value, symbol = param.symbol, _type = param.type, type = _type === void 0 ? "update_general_pricedata" : _type;
    return useOrderbookStore.setState(function(state) {
        return (0,immer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(state, function(draft) {
            var ref;
            var draftSymbol = ((ref = draft[key]) === null || ref === void 0 ? void 0 : ref[symbol]) || {};
            draft[key][symbol] = TYPE_SET[type](draftSymbol, value);
            return;
        });
    });
};
var setValueBatch = function(payload) {
    return useOrderbookStore.setState(function(state) {
        return produce(state, function(draft) {
            payload.map(function(item) {
                var ref;
                var _payload = item.payload, value = _payload.data, index = _payload.index, type = item.name;
                var draftSymbol = ((ref = draft["liveprice"]) === null || ref === void 0 ? void 0 : ref[index]) || {};
                draft["liveprice"][index] = TYPE_SET[type](draftSymbol, value);
            });
            return draft;
        });
    });
};


/***/ }),

/***/ 91364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2497);
/* harmony import */ var global_WebSocket_slice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23985);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var global_Notification__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77667);
/* harmony import */ var lib_entities_notification_useNotificationData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89790);





var PRICE_ALERT_KEY = "price-alert";
function useNotificationListener() {
    var isUserLogin = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    var unread = (0,lib_entities_notification_useNotificationData__WEBPACK_IMPORTED_MODULE_4__/* .useNotificationData */ .z)(function(store) {
        return store.unread;
    });
    var setUnread = (0,lib_entities_notification_useNotificationData__WEBPACK_IMPORTED_MODULE_4__/* .useNotificationData */ .z)(function(store) {
        return store.setUnread;
    });
    var notification = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(global_WebSocket_slice__WEBPACK_IMPORTED_MODULE_1__/* .notifWsSelector */ .i9);
    var notificationListener = function() {
        var notif = notification[notification.length - 1];
        // Update unread notification
        setUnread(unread + 1);
        var onClose = function() {
            return dispatch(global_WebSocket_slice__WEBPACK_IMPORTED_MODULE_1__/* ["default"].actions.resetNotification */ .ZP.actions.resetNotification());
        };
        // Show notification on left bottom side
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        (0,global_Notification__WEBPACK_IMPORTED_MODULE_3__/* .showGeneralNotification */ .uw)(notif, onClose);
    };
    var getPriceAlertFromLocalStorage = function() {
        var alertRaw = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(PRICE_ALERT_KEY);
        if (alertRaw) {
            try {
                return JSON.parse(alertRaw);
            } catch (e) {
                return false;
            }
        }
        return false;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!isUserLogin) return;
        if ((notification === null || notification === void 0 ? void 0 : notification.length) > 0) {
            notificationListener();
        }
    }, [
        notification === null || notification === void 0 ? void 0 : notification.length,
        isUserLogin
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!isUserLogin) return;
        var alert = getPriceAlertFromLocalStorage();
        if (alert) {
            dispatch(global_WebSocket_slice__WEBPACK_IMPORTED_MODULE_1__/* ["default"].actions.setAlert */ .ZP.actions.setAlert(alert));
        }
    }, [
        isUserLogin
    ]);
    return null;
}
/* harmony default export */ __webpack_exports__["Z"] = (useNotificationListener);


/***/ }),

/***/ 30995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2497);
/* harmony import */ var lib_entities_profile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(333);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19225);




function useProfileData() {
    // get data from reducer
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    // get data from profile
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(lib_entities_profile__WEBPACK_IMPORTED_MODULE_2__/* .selectors */ .wl), dataProfile = ref.data;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // check if profile data is available
        var parsedCookie = utils_auth__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getToken */ .Z.getToken();
        if (parsedCookie) {
            var token = parsedCookie.accessToken.token;
            // check if there's token but empty data profile
            if (token && !dataProfile.id) {
                var userAccess = utils_auth__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getUserAccess */ .Z.getUserAccess();
                // @ts-ignore
                var username = userAccess.username;
                // get user data profile
                // @ts-ignore
                dispatch(lib_entities_profile__WEBPACK_IMPORTED_MODULE_2__/* .effects.getUserProfile */ .Sz.getUserProfile(username));
            }
        }
    }, [
        dispatch,
        dataProfile
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useProfileData);


/***/ }),

/***/ 56198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2497);
/* harmony import */ var lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21671);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19225);




//  Utils

function useProtectedRoute() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isLoaded = ref[0], setIsLoaded = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var isLoggedIn = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__/* .selectors */ .wl).isLoggedIn;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        var token = utils_auth__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getToken */ .Z.getToken();
        if (!isLoggedIn && !(token === null || token === void 0 ? void 0 : (ref = token.accessToken) === null || ref === void 0 ? void 0 : ref.token)) {
            // @ts-ignore
            dispatch(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__/* .effects.logout */ .Sz.logout());
            router.push("/login");
            return;
        }
        setIsLoaded(true);
    }, [
        dispatch,
        isLoggedIn,
        router
    ]);
    return {
        isLoaded: isLoaded
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useProtectedRoute);


/***/ }),

/***/ 89790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useNotificationData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var zustand_middleware_immer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42435);
/* harmony import */ var lib_api_notification__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99368);
/* harmony import */ var utils_notification__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25178);









var useNotificationData = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)((0,zustand_middleware_immer__WEBPACK_IMPORTED_MODULE_4__/* .immer */ .n)(function(set) {
    return {
        tab: "notification",
        isPopupOpen: false,
        isConvoOpen: false,
        isReading: false,
        isLoading: false,
        isLoadingPrevious: false,
        contents: {
            notification: {
                list: [],
                lastId: null
            },
            mention: {
                list: [],
                lastId: null
            },
            report: {
                list: [],
                lastId: null
            },
            tipping: {
                list: [],
                lastId: null
            }
        },
        unread: 0,
        // UI Reducers
        changeTab: function changeTab(tab) {
            set(function(draft) {
                draft.tab = tab;
            });
        },
        togglePopup: function togglePopup() {
            set(function(draft) {
                draft.isPopupOpen = !draft.isPopupOpen;
            });
        },
        closePopup: function closePopup() {
            set(function(draft) {
                draft.isPopupOpen = false;
            });
        },
        setConvoOpen: function setConvoOpen(id) {
            var isOpen = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            set(function(draft) {
                draft.isConvoOpen = isOpen;
                draft.convoId = id;
            });
        },
        closeConvo: function closeConvo() {
            set(function(draft) {
                draft.isConvoOpen = false;
                draft.convoId = undefined;
            });
        },
        setUnread: function setUnread(count) {
            set(function(draft) {
                draft.unread = count;
            });
        },
        getNotification: // Asynchronous actions
        function getNotification1(tab) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var typeParams, ref, data, status, _data, result, unread;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(draft) {
                                draft.isLoading = true;
                            });
                            typeParams = utils_notification__WEBPACK_IMPORTED_MODULE_2__/* .notificationTabsAttrs.find */ .jg.find(function(item) {
                                return item.name === tab;
                            });
                            _ctx.next = 5;
                            return (0,lib_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .getNotification */ .v6)(typeParams.typeCodes);
                        case 5:
                            ref = _ctx.sent;
                            data = ref.data;
                            status = ref.status;
                            if (!(status !== 200)) {
                                _ctx.next = 10;
                                break;
                            }
                            throw new Error(data.error || data.error_type);
                        case 10:
                            _data = data.data, result = _data.result, unread = _data.unread;
                            set(function(draft) {
                                draft.unread = unread;
                                draft.contents[tab].list = result;
                                draft.isLoading = false;
                                if (result.length - 1 >= 0) {
                                    draft.contents[tab].lastId = result[result.length - 1].id;
                                }
                            });
                            _ctx.next = 17;
                            break;
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(draft) {
                                draft.errorMessage = _ctx.t0.message;
                                draft.isLoading = false;
                            });
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        14
                    ]
                ]);
            }))();
        },
        getPrevNotification: function getPrevNotification(tab, lastId) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var typeParams, ref, data, status, _data, result, unread;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            // if previous
                            set(function(draft) {
                                draft.isLoadingPrevious = true;
                            });
                            typeParams = utils_notification__WEBPACK_IMPORTED_MODULE_2__/* .notificationTabsAttrs.find */ .jg.find(function(item) {
                                return item.name === tab;
                            });
                            _ctx.next = 4;
                            return (0,lib_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .getNotification */ .v6)(typeParams.typeCodes, 25, lastId);
                        case 4:
                            ref = _ctx.sent;
                            data = ref.data;
                            status = ref.status;
                            if (!(status !== 200)) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(data.error || data.error_type);
                        case 9:
                            _data = data.data, result = _data.result, unread = _data.unread;
                            set(function(draft) {
                                draft.unread = unread;
                                draft.contents[tab].list = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(draft.contents[tab].list).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(result));
                                draft.isLoadingPrevious = false;
                                if (result.length - 1 >= 0) {
                                    draft.contents[tab].lastId = result[result.length - 1].id;
                                }
                            });
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        getUnreadCount: function getUnreadCount() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var ref, data, status, result;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(draft) {
                                draft.errorMessage = undefined;
                            });
                            _ctx.next = 4;
                            return (0,lib_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .getUnreadNotificationNumber */ .O7)();
                        case 4:
                            ref = _ctx.sent;
                            data = ref.data;
                            status = ref.status;
                            if (!(status !== 200)) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(data.error || data.error_type);
                        case 9:
                            result = data.data;
                            if (!result) {
                                _ctx.next = 14;
                                break;
                            }
                            {
                                set(function(draft) {
                                    draft.unread = result.unread;
                                });
                            }
                            _ctx.next = 15;
                            break;
                        case 14:
                            throw new Error("failed to read notification");
                        case 15:
                            _ctx.next = 20;
                            break;
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(draft) {
                                draft.errorMessage = _ctx.t0.message;
                            });
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        17
                    ]
                ]);
            }))();
        },
        markNotifAsRead: function markNotifAsRead() {
            var tab = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "notification";
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var typeParams, ref, data, status, result;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(draft) {
                                draft.errorMessage = undefined;
                                draft.isReading = true;
                            });
                            typeParams = utils_notification__WEBPACK_IMPORTED_MODULE_2__/* .notificationTabsAttrs.find */ .jg.find(function(item) {
                                return item.name === tab;
                            });
                            _ctx.next = 5;
                            return (0,lib_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .markAsRead */ .zJ)(typeParams.typeCodes);
                        case 5:
                            ref = _ctx.sent;
                            data = ref.data;
                            status = ref.status;
                            if (!(status !== 200)) {
                                _ctx.next = 10;
                                break;
                            }
                            throw new Error(data.error || data.error_type);
                        case 10:
                            result = data.data;
                            if (!result) {
                                _ctx.next = 15;
                                break;
                            }
                            {
                                set(function(draft) {
                                    draft.unread = 0;
                                    draft.isReading = false;
                                    draft.contents[tab].list = draft.contents[tab].list.map(function(item) {
                                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, item), {
                                            is_read: true
                                        });
                                    });
                                });
                            }
                            _ctx.next = 16;
                            break;
                        case 15:
                            throw new Error("failed to read notification");
                        case 16:
                            _ctx.next = 21;
                            break;
                        case 18:
                            _ctx.prev = 18;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(draft) {
                                draft.errorMessage = _ctx.t0.message;
                                draft.isReading = false;
                            });
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        18
                    ]
                ]);
            }))();
        }
    };
}));


/***/ }),

/***/ 34737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A3": function() { return /* binding */ FLIPT_URL_HOST; },
/* harmony export */   "HZ": function() { return /* binding */ FLIPT_TOKEN; },
/* harmony export */   "Ii": function() { return /* binding */ FLIPT_CHARTBIT_NAMESPACE; },
/* harmony export */   "S3": function() { return /* binding */ FLIPT_DESKTOP_NAMESPACE; },
/* harmony export */   "Vr": function() { return /* binding */ FLIPT_CHARTBIT_TOKEN; },
/* harmony export */   "WQ": function() { return /* binding */ FLIPT_FINANCIAL_DATA_NAMESPACE; },
/* harmony export */   "ad": function() { return /* binding */ FLIPT_NAMESPACE; },
/* harmony export */   "g0": function() { return /* binding */ FLIPT_FINANCIAL_DATA_TOKEN; },
/* harmony export */   "uL": function() { return /* binding */ FLIPT_DESKTOP_TOKEN; }
/* harmony export */ });
// Environment variables
var _NEXT_PUBLIC_FLIPT_URL_HOST;
var FLIPT_URL_HOST = (_NEXT_PUBLIC_FLIPT_URL_HOST = "https://flipt.stockbit.com") !== null && _NEXT_PUBLIC_FLIPT_URL_HOST !== void 0 ? _NEXT_PUBLIC_FLIPT_URL_HOST : "";
var _NEXT_PUBLIC_FLIPT_NAMESPACE;
var FLIPT_NAMESPACE = (_NEXT_PUBLIC_FLIPT_NAMESPACE = "transaction") !== null && _NEXT_PUBLIC_FLIPT_NAMESPACE !== void 0 ? _NEXT_PUBLIC_FLIPT_NAMESPACE : "";
var _NEXT_PUBLIC_FLIPT_TOKEN;
var FLIPT_TOKEN = (_NEXT_PUBLIC_FLIPT_TOKEN = "3m1ehM_SYRRg0NDWbzixtn4O5ZcVWaaQW7ytx7NAm0A=") !== null && _NEXT_PUBLIC_FLIPT_TOKEN !== void 0 ? _NEXT_PUBLIC_FLIPT_TOKEN : undefined;
var _NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE;
var FLIPT_CHARTBIT_NAMESPACE = (_NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE = "chartbit") !== null && _NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE !== void 0 ? _NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE : "";
var _NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN;
var FLIPT_CHARTBIT_TOKEN = (_NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN = "N58pKzjn1zMJNwH5pGTOwy3-ufiL1Xdb0VQmRCl5kek=") !== null && _NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN !== void 0 ? _NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN : undefined;
var _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_TOKEN;
var FLIPT_FINANCIAL_DATA_TOKEN = (_NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_TOKEN = "7BcKXp5uJ9xPlBrKLorMCGWnzM4zE6PoPkYXdh5iMys=") !== null && _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_TOKEN !== void 0 ? _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_TOKEN : undefined;
var _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_NAMESPACE;
var FLIPT_FINANCIAL_DATA_NAMESPACE = (_NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_NAMESPACE = "financial-data") !== null && _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_NAMESPACE !== void 0 ? _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_NAMESPACE : "";
var _NEXT_PUBLIC_FLIPT_DESKTOP_TOKEN;
var FLIPT_DESKTOP_TOKEN = (_NEXT_PUBLIC_FLIPT_DESKTOP_TOKEN = "Kmho-j0dflXhQTvnnNA7y_tkuUN16W-Sg7pUo2hWPUg=") !== null && _NEXT_PUBLIC_FLIPT_DESKTOP_TOKEN !== void 0 ? _NEXT_PUBLIC_FLIPT_DESKTOP_TOKEN : undefined;
var _NEXT_PUBLIC_FLIPT_DESKTOP_NAMESPACE;
var FLIPT_DESKTOP_NAMESPACE = (_NEXT_PUBLIC_FLIPT_DESKTOP_NAMESPACE = "desktop-production") !== null && _NEXT_PUBLIC_FLIPT_DESKTOP_NAMESPACE !== void 0 ? _NEXT_PUBLIC_FLIPT_DESKTOP_NAMESPACE : "";


/***/ }),

/***/ 34540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ FeatureFlagKeys; }
/* harmony export */ });
/**
 * Flag conventions
 * [platform]-[flag-type]-[feature-name]
 *
 * Platform:
 *   - all: all platform
 *   - android: android only
 *   - ios: ios only
 *   - web: web only
 * Flag Type:
 *   - b: boolean
 *   - v: variant
 * Feature name:
 *   - name of the feature with dash as separator
 *
 * Example:
 *   - web-b-split-order
 *   - all-v-language
 */ var FeatureFlagKeys;
(function(FeatureFlagKeys) {
    FeatureFlagKeys["SPLIT_ORDER"] = "all-b-split-order-eligibility";
    FeatureFlagKeys["FAST_ORDER"] = "web-b-fast-trade-eligibility";
    FeatureFlagKeys["TRAILING_STOP"] = "web-b-trailing-stop-eligibility";
    FeatureFlagKeys["DAY_TRADE"] = "all-b-day-trade-eligibility";
    FeatureFlagKeys["MARKET_ORDER"] = "enable-market-order";
    FeatureFlagKeys["FAST_ORDER_DUPLICATE_BIDOFFER"] = "web-b-fast-trade-duplicate-bidoffer";
    FeatureFlagKeys["CHARTBIT_MAINTENANCE"] = "chartbit_maintenance";
    FeatureFlagKeys["CHARTBIT_DEBUG"] = "chartbit_debug";
    FeatureFlagKeys["CHARTBIT_DISABLE_AUTOSAVE"] = "chartbit_disable_autosave";
    FeatureFlagKeys["CHARTBIT_IFRAME_LOGGING"] = "chartbit_iframe_logging";
    FeatureFlagKeys["CHARTBIT_TRADE_FROM_CHART"] = "chartbit_trade_from_chart";
    FeatureFlagKeys["TOP_STOCKS"] = "all-b-top-stock-eligibility";
    FeatureFlagKeys["DISABLE_DATE_BEFORE"] = "disable-date-before";
    FeatureFlagKeys["RUNNING_TRADE_CHART"] = "all-b-running-trade-chart-eligibility";
    FeatureFlagKeys["RUNNING_TRADE_CHART_FILTER"] = "all-b-running-trade-chart-date-filter-eligibility";
    FeatureFlagKeys["KEYSTAT_DIVIDEND"] = "all-b-keystat-dividend";
    FeatureFlagKeys["WEB_TRENDING_CHART"] = "web-b-trending-chart";
})(FeatureFlagKeys || (FeatureFlagKeys = {}));


/***/ }),

/***/ 62514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* reexport */ useFliptBoolean; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
// EXTERNAL MODULE: ./src/lib/flipt/store/useFliptStore.ts + 4 modules
var useFliptStore = __webpack_require__(90060);
;// CONCATENATED MODULE: ./src/lib/flipt/hooks/useFliptBoolean.ts



function useFliptBoolean(flagKey, alwaysLoad, namespaceKey) {
    var featureFlags = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.getUIValue("featureFlags");
    });
    var loadBooleanEvaluation = (0,useFliptStore/* default */.Z)(function(s) {
        return s.loadBooleanEvaluation;
    });
    var namespace = namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : undefined;
    var flag = featureFlags ? featureFlags[flagKey] : undefined;
    (0,react.useEffect)(function() {
        if (flag && !alwaysLoad) {
            return;
        }
        loadBooleanEvaluation(flagKey, namespace);
    }, [
        flagKey,
        flag,
        alwaysLoad
    ]);
    return flag ? flag.isEnabled : false;
};

;// CONCATENATED MODULE: ./src/lib/flipt/hooks/index.ts



/***/ }),

/***/ 90060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ store_useFliptStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
;// CONCATENATED MODULE: ./src/lib/flipt/constants/endpoints.ts
// endpoints
var endpoints = {
    evaluate: {
        boolean: "evaluate/v1/boolean",
        variant: "evaluate/v1/variant",
        batch: "evaluate/v1/batch"
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/lib/flipt/constants/env.ts
var env = __webpack_require__(34737);
;// CONCATENATED MODULE: ./src/lib/flipt/instance.ts




var fliptApi = axios_default().create({
    baseURL: env/* FLIPT_URL_HOST */.A3,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
    }
});
fliptApi.interceptors.request.use(function(config) {
    if (env/* FLIPT_TOKEN */.HZ) {
        // eslint-disable-next-line no-param-reassign
        config.headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.headers), {
            Authorization: "Bearer ".concat(env/* FLIPT_TOKEN */.HZ)
        });
    }
    return config;
});
var fliptChartbitApi = axios_default().create({
    baseURL: env/* FLIPT_URL_HOST */.A3,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
    }
});
fliptChartbitApi.interceptors.request.use(function(config) {
    if (env/* FLIPT_CHARTBIT_TOKEN */.Vr) {
        // eslint-disable-next-line no-param-reassign
        config.headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.headers), {
            Authorization: "Bearer ".concat(env/* FLIPT_CHARTBIT_TOKEN */.Vr)
        });
    }
    return config;
});
var fliptFinancialDataApi = axios_default().create({
    baseURL: env/* FLIPT_URL_HOST */.A3,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
    }
});
fliptFinancialDataApi.interceptors.request.use(function(config) {
    if (env/* FLIPT_FINANCIAL_DATA_TOKEN */.g0) {
        // eslint-disable-next-line no-param-reassign
        config.headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.headers), {
            Authorization: "Bearer ".concat(env/* FLIPT_FINANCIAL_DATA_TOKEN */.g0)
        });
    }
    return config;
});
var fliptDesktopApi = axios_default().create({
    baseURL: env/* FLIPT_URL_HOST */.A3,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
    }
});
fliptDesktopApi.interceptors.request.use(function(config) {
    if (env/* FLIPT_DESKTOP_NAMESPACE */.S3) {
        // eslint-disable-next-line no-param-reassign
        config.headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.headers), {
            Authorization: "Bearer ".concat(env/* FLIPT_DESKTOP_TOKEN */.uL)
        });
    }
    return config;
});

;// CONCATENATED MODULE: ./src/lib/flipt/helpers.ts

var createEntityID = function(userId) {
    return "web-".concat(userId);
};
var createEvaluationPayload = function(userId, flagKey, namespaceKey) {
    return {
        context: {
            user_id: userId
        },
        entityId: createEntityID(userId),
        flagKey: flagKey,
        namespaceKey: namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : env/* FLIPT_NAMESPACE */.ad
    };
};

;// CONCATENATED MODULE: ./src/lib/flipt/endpoints.ts




var getService = function(service) {
    if (service === "chartbit") {
        return fliptChartbitApi;
    }
    if (service === "financial-data") {
        return fliptFinancialDataApi;
    }
    if (service.includes("desktop")) {
        return fliptDesktopApi;
    }
    return fliptApi;
};
// endpoints handlers
var evaluateBoolean = function(userId, flagKey, namespaceKey) {
    var api = namespaceKey ? getService(namespaceKey) : fliptApi;
    return api.post(endpoints.evaluate.boolean, createEvaluationPayload(userId, flagKey, namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : env/* FLIPT_NAMESPACE */.ad));
};
var evaluateVariant = function(userId, flagKey, namespaceKey) {
    var api = namespaceKey ? getService(namespaceKey) : fliptApi;
    return api.post(endpoints.evaluate.variant, createEvaluationPayload(userId, flagKey, namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : env/* FLIPT_NAMESPACE */.ad));
};

;// CONCATENATED MODULE: ./src/lib/flipt/store/useFliptStore.ts





var useFliptStore = (0,esm/* default */.ZP)(function(set, get) {
    return {
        setUserId: function setUserId(userId) {
            set({
                userId: String(userId)
            });
        },
        loadBooleanEvaluation: function loadBooleanEvaluation(flagKey, namespaceKey) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var userId, ref, getUIValue, setUIValue, featureFlags, namespace, response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            userId = get().userId;
                            if (userId) {
                                _ctx.next = 5;
                                break;
                            }
                            // Return a rejected promise if user id is not found
                            // to prevent the function from continuing
                            Promise.reject(new Error("user id is not found"));
                            return _ctx.abrupt("return", false);
                        case 5:
                            ref = useUIConfigStore/* default.getState */.Z.getState(), getUIValue = ref.getUIValue, setUIValue = ref.setUIValue;
                            featureFlags = getUIValue("featureFlags");
                            if (!(featureFlags && featureFlags[flagKey])) {
                                _ctx.next = 9;
                                break;
                            }
                            return _ctx.abrupt("return", featureFlags[flagKey].isEnabled);
                        case 9:
                            namespace = namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : "transaction";
                            _ctx.next = 12;
                            return evaluateBoolean(userId, flagKey, namespace);
                        case 12:
                            response = _ctx.sent;
                            setUIValue("featureFlags", function(draft) {
                                draft[flagKey] = {
                                    isEnabled: response.data.enabled
                                };
                            });
                            return _ctx.abrupt("return", response.data.enabled);
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                            return _ctx.abrupt("return", false);
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        17
                    ]
                ]);
            }))();
        },
        loadVariantEvaluation: function loadVariantEvaluation(flagKey, namespaceKey) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var userId, ref, getUIValue, setUIValue, response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            userId = get().userId;
                            if (userId) {
                                _ctx.next = 5;
                                break;
                            }
                            // Return a rejected promise if user id is not found
                            // to prevent the function from continuing
                            Promise.reject(new Error("user id is not found"));
                            return _ctx.abrupt("return", false);
                        case 5:
                            ref = useUIConfigStore/* default.getState */.Z.getState(), getUIValue = ref.getUIValue, setUIValue = ref.setUIValue;
                            _ctx.next = 8;
                            return evaluateVariant(userId, flagKey, namespaceKey);
                        case 8:
                            response = _ctx.sent;
                            setUIValue("featureFlags", function(draft) {
                                draft[flagKey] = {
                                    variance: response.data
                                };
                            });
                            return _ctx.abrupt("return", response.data);
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                            return _ctx.abrupt("return", false);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }))();
        }
    };
});
/* harmony default export */ var store_useFliptStore = (useFliptStore);


/***/ }),

/***/ 7639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stores_useUIConfigStore; }
});

// UNUSED EXPORTS: resetRules

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware.js
var middleware = __webpack_require__(38597);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./src/typings/auth.ts
var typings_auth = __webpack_require__(97718);
;// CONCATENATED MODULE: ./src/utils/objectOperations.ts

var pickObject = function(obj, keys) {
    var pickedObject = {};
    keys.forEach(function(key) {
        pickedObject[key] = obj === null || obj === void 0 ? void 0 : obj[key];
    });
    return pickedObject;
};
var omitObject = function(obj, keys) {
    var omittedObject = (0,_object_spread/* default */.Z)({}, obj);
    keys.forEach(function(key) {
        return delete omittedObject[key];
    });
    return omittedObject;
};

;// CONCATENATED MODULE: ./src/stores/useUIConfigStore/index.ts









var _obj;
var resetRules = (_obj = {}, // List item that should not deleted on social logout
(0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Social */.B.Social, [
    "tradingLimitTooltip",
    "tradingLimitTnc",
    // Day Trade
    "dayTradeTnc",
    "dayTradeTncShown", 
]), // List item that should be deleted on securities logout
(0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Securities */.B.Securities, [
    "featureFlags"
]), _obj);
var initialState = {
    userConfig: {}
};
var useUIConfigStore = (0,esm/* default */.ZP)((0,middleware/* persist */.tJ)(function(set, get) {
    var ref, ref1, ref2;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        setUIValue: function(key, value) {
            var userId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (ref = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref === void 0 ? void 0 : ref.id;
            set((0,immer_esm/* default */.ZP)(function(state) {
                if (!state.userConfig[userId]) state.userConfig[userId] = {};
                if (typeof value === "function") {
                    if (!state.userConfig[userId][key]) {
                        state.userConfig[userId] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.userConfig[userId]), (0,_define_property/* default */.Z)({}, key, {}));
                    }
                    value(state.userConfig[userId][key]);
                    return;
                }
                state.userConfig[userId][key] = value;
            }));
        },
        getUIValue: function(key) {
            var userId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (ref1 = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref1 === void 0 ? void 0 : ref1.id;
            var ref;
            return (ref = get().userConfig[userId]) === null || ref === void 0 ? void 0 : ref[key];
        },
        resetUIValue: function(loginType) {
            var userId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (ref2 = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref2 === void 0 ? void 0 : ref2.id;
            var resetSocial = function() {
                set((0,immer_esm/* default */.ZP)(function(state) {
                    state.userConfig[userId] = pickObject(state.userConfig[userId], resetRules[typings_auth/* LoginType.Social */.B.Social]);
                }));
            };
            var resetSecurities = function() {
                set((0,immer_esm/* default */.ZP)(function(state) {
                    state.userConfig[userId] = omitObject(state.userConfig[userId], resetRules[typings_auth/* LoginType.Securities */.B.Securities]);
                }));
            };
            var _obj;
            var resetActions = (_obj = {}, (0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Social */.B.Social, resetSocial), (0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Securities */.B.Securities, resetSecurities), _obj);
            resetActions[loginType]();
        }
    });
}, {
    name: "UIConfigStore"
}));
/* harmony default export */ var stores_useUIConfigStore = (useUIConfigStore);


/***/ }),

/***/ 97718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ LoginType; },
/* harmony export */   "z": function() { return /* binding */ OtpChannel; }
/* harmony export */ });
var LoginType;
(function(LoginType) {
    LoginType["Social"] = "social";
    LoginType["Securities"] = "securities";
})(LoginType || (LoginType = {}));
var OtpChannel;
(function(OtpChannel) {
    OtpChannel["Unspecified"] = "CHANNEL_UNSPECIFIED";
    OtpChannel["Sms"] = "CHANNEL_SMS";
    OtpChannel["WhatsApp"] = "CHANNEL_WHATSAPP";
})(OtpChannel || (OtpChannel = {}));


/***/ }),

/***/ 42435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ immer; }
/* harmony export */ });
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12902);


const immerImpl = (initializer) => (set, get, store) => {
  store.setState = (updater, replace, ...a) => {
    const nextState = typeof updater === "function" ? (0,immer__WEBPACK_IMPORTED_MODULE_0__/* .produce */ .Uy)(updater) : updater;
    return set(nextState, replace, ...a);
  };
  return initializer(store.setState, get, store);
};
const immer = immerImpl;




/***/ }),

/***/ 20:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/backpack/1.0.0/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["backpack"]) {
      return resolve(window.remoteLoading["backpack"])
    }

    var res, rej;
    window.remoteLoading["backpack"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["backpack"] !== 'undefined') {
      res(window["backpack"]);
      return resolve(window["backpack"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["backpack"] !== 'undefined') {
          res(window["backpack"]);
          return resolve(window["backpack"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "backpack"
    );
  }).then(function () {
    const proxy = {
      get: backpack.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          backpack.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        backpack.__initialized = true
      }
    }
    if (!backpack.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 5693:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/buy-sell/1.5.9/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["buysell"]) {
      return resolve(window.remoteLoading["buysell"])
    }

    var res, rej;
    window.remoteLoading["buysell"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["buysell"] !== 'undefined') {
      res(window["buysell"]);
      return resolve(window["buysell"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["buysell"] !== 'undefined') {
          res(window["buysell"]);
          return resolve(window["buysell"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "buysell"
    );
  }).then(function () {
    const proxy = {
      get: buysell.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          buysell.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        buysell.__initialized = true
      }
    }
    if (!buysell.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 94673:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/fast-trade/1.1.6/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["fasttrade"]) {
      return resolve(window.remoteLoading["fasttrade"])
    }

    var res, rej;
    window.remoteLoading["fasttrade"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["fasttrade"] !== 'undefined') {
      res(window["fasttrade"]);
      return resolve(window["fasttrade"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["fasttrade"] !== 'undefined') {
          res(window["fasttrade"]);
          return resolve(window["fasttrade"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "fasttrade"
    );
  }).then(function () {
    const proxy = {
      get: fasttrade.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          fasttrade.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        fasttrade.__initialized = true
      }
    }
    if (!fasttrade.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 2680:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/movers/1.0.2/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["movers"]) {
      return resolve(window.remoteLoading["movers"])
    }

    var res, rej;
    window.remoteLoading["movers"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["movers"] !== 'undefined') {
      res(window["movers"]);
      return resolve(window["movers"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["movers"] !== 'undefined') {
          res(window["movers"]);
          return resolve(window["movers"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "movers"
    );
  }).then(function () {
    const proxy = {
      get: movers.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          movers.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        movers.__initialized = true
      }
    }
    if (!movers.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 85611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/top-stocks/1.0.1/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["topstocks"]) {
      return resolve(window.remoteLoading["topstocks"])
    }

    var res, rej;
    window.remoteLoading["topstocks"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["topstocks"] !== 'undefined') {
      res(window["topstocks"]);
      return resolve(window["topstocks"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["topstocks"] !== 'undefined') {
          res(window["topstocks"]);
          return resolve(window["topstocks"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "topstocks"
    );
  }).then(function () {
    const proxy = {
      get: topstocks.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          topstocks.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        topstocks.__initialized = true
      }
    }
    if (!topstocks.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [74885,63332,25287,94119,78656,71577,75819,88069,46819,7648,25935,51225,80129,40142,80737,50299,77549,92961,54253,54005,33070,58928,92077,76750,79931,42298,35851,36055,67555,80822,61980,16735,82227,44912,62571,21671,74768,36902,41057,79624,29184,42234,58947,65613,51642,18566,49774,92888,40179], function() { return __webpack_exec__(72728); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);